import CreateGenerator from './CreateGenerator'

export default CreateGenerator
